import { QueryClient, isServer } from "@tanstack/react-query";
import { cache } from "react";

export function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // 1 second staleTime to avoid immediate refetch on the client in SSR
        staleTime: 1000 * 60,
        refetchOnMount: false,
        refetchOnWindowFocus: false
      }
    }
  });
}

export const getCachedQueryClient = cache(makeQueryClient);

let browserQueryClient: QueryClient | undefined = undefined;

function getQueryClient() {
  if (isServer) {
    return makeQueryClient();
  } else {
    if (!browserQueryClient) {
      browserQueryClient = makeQueryClient();
    }
    return browserQueryClient;
  }
}
export default getQueryClient;
